import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { BdmassessmentService } from './bdm-assessment-services/bdmassessment.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { ViewBdmassessment } from './bdm-assessment-interfaces/view-bdmassessment.interface';
import { HttpStatusCode } from 'axios';
import { ConfirmPopupComponent } from '../new-rep-application/confirm-popup/confirm-popup.component';
import { Bdmassessmentmodels } from './bdm-assessment-models/bdmassessmentmodels.models';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnboardingAssesmentModel } from '../onboarding-assessment/onboarding-assesment-models/onboarding-assesment-model.model';
import { OnboardingAssessmentService } from '../onboarding-assessment/onboarding-assessment-services/onboarding-assessment.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OnboardingAssesment } from '../onboarding-assessment/onboarding-assesment-interface/onboarding-assesment.interface';
import { NewRepChecklistService } from '../new-rep-checklist/new-rep-checklist-services/new-rep-checklist.service';
import { getChecklistItems } from '../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { DocumentPreviewOverlayDirective } from '../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';
import { noWhitespace } from '../../../shared/validators/no-whitespace.validator';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-bdm-assessment',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective,
  ],
  templateUrl: './bdm-assessment.component.html',
  styleUrl: './bdm-assessment.component.scss'
})
export class BdmAssessmentComponent implements OnInit {

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private sanitizer = inject(DomSanitizer);
  readonly message = ' This field is required.';
  private sessionStorageService = inject(SessionStorageService);
  private bdmassessmentService = inject(BdmassessmentService);
  private documentUploadService = inject(OnboardingAssessmentService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);
  submitted = signal(false);
  errormessage!: string;

  data = history.state;
  viewId!: number;
  viewbdmAssessment!: ViewBdmassessment;
  getBdmdocuments!: OnboardingAssesment[];
  isReadOnly = signal(false);
  protected getchecklistItems: getChecklistItems[] = [];
  checklistinvalidflag = signal(false);

  /** Prefix used for the dynamically added "Other Attachments" controls. */
  readonly otherAttachmentPrefix = 'otherAttachment';
  /** Document type sent for every "Other Attachments" upload - the row index goes in responseValue. */
  readonly otherAttachmentDescription = 'OtherAttachments';
  /** Control keys of the rendered "Other Attachments" rows, e.g. ['otherAttachment1', 'otherAttachment2']. */
  otherAttachmentKeys: string[] = [];
  private otherAttachmentSeq = 0;

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedItemFile!: string;
  currentFileName!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  // Initialize the form directly here. No more "addControl" needed!
  public assessmentForm: FormGroup = this.fb.group({
    name: [''],
    manager: [''],
    bdmname: [''],
    remarks: [''],
    date: [''],
    recruitmentQuestionnaires_1: ['', [Validators.required]],
    recruitmentQuestionnairesyes_1_1: [''],
    recruitmentQuestionnairesyes_1_2: [''],
    recruitmentQuestionnaires_2: ['', [Validators.required]],
    recruitmentQuestionnairesyes_2: [''],
    recruitmentQuestionnaires_3: ['', [Validators.required]],
    recruitmentQuestionnaires_4: ['', [Validators.required]],
    recruitmentQuestionnaires_5: ['', [Validators.required]],
    recruitmentQuestionnairesno_5: [''],
    recruitmentQuestionnaires_6: ['', [Validators.required]],
    recruitmentQuestionnairesyes_6: [''],
    recruitmentQuestionnaires_7: ['', [Validators.required]],
    recruitmentQuestionnaires_8: ['', [Validators.required]],
    recruitmentQuestionnaires_9: ['', [Validators.required]],
    recruitmentQuestionnairesyes_9_1: [''],
    recruitmentQuestionnairesyes_9_2: [''],
    recruitmentQuestionnairesno_9: [''],
    recruitmentQuestionnaires_10: ['', [Validators.required]],
    recruitmentQuestionnaires_11: ['', [Validators.required]],
    recruitmentQuestionnaires_12: ['', [Validators.required]],
    recruitmentQuestionnaires_13: ['', [Validators.required]],
    recruitmentQuestionnaires_14: ['', [Validators.required]],
    recruitmentQuestionnaires_15: ['', [Validators.required]],
    recruitmentQuestionnairesyes_15: [''],
    declarationaccepted: ['', [Validators.required]],
    medisavePayableStatementbyCPFBoard: [null],
    medisavePayableStatementbyCPFBoardfileName: ['', [Validators.required]],
    adviserAgreement: [null],
    adviserAgreementfileName: ['', [Validators.required]],
    cdoApproval: [null],
    cdoApprovalfileName: ['', [Validators.required]],


  });

  constructor() { }

  onCheckboxChange(checked: boolean, value: boolean, field: any, index: number) {
    if (checked) {
      this.assessmentForm.get(field)?.setValue(value);
      this.assessmentForm.get(field)?.markAsUntouched();
      if (this.assessmentForm.get(field)?.value == true) {
        if (index === 1 || index === 9) {
          this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_1')?.setValidators([Validators.required, noWhitespace]);
          this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_2')?.setValidators([Validators.required, noWhitespace]);
          if (index === 9) {
            this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.clearValidators();
            this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.reset();
          }

        } else if (index === 2 || index === 6 || index === 15) {
          this.assessmentForm.get('recruitmentQuestionnairesyes_' + index)?.setValidators([Validators.required, noWhitespace]);
        } else if (index === 5) {
          this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.clearValidators();
          this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.reset();
        }
      } else if (this.assessmentForm.get(field)?.value == false && (index === 5 || index === 9)) {
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_1')?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_2')?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_1')?.reset();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_2')?.reset();
        this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.setValidators([Validators.required, noWhitespace]);
      } else {
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index)?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index)?.reset();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_1')?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_1')?.reset();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_2')?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesyes_' + index + '_2')?.reset();
        this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.clearValidators();
        this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.reset();
      }
    } else {
      this.assessmentForm.get(field)?.setValue(null);
      this.assessmentForm.get(field)?.markAsTouched();
      this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.clearValidators();
      this.assessmentForm.get('recruitmentQuestionnairesno_' + index)?.reset();
    }
  }

  ngOnInit(): void {
    // Logic is now handled in the property initialization above
    this.viewId = this.data.id;
    this.viewBdmAssessment();
    this.getChecklistItems();
    this.isReadOnly.set(this.data.isReadOnly);
    if (this.isReadOnly() == true) {
      this.assessmentForm?.disable();
    } else {
      this.assessmentForm?.enable();
    }

    this.assessmentForm.get('declarationaccepted')?.valueChanges.subscribe(value => {
      if (value) {
        this.assessmentForm.patchValue({
          bdmname: this.sessionStorageService.getCurrentUserPersonName(),
          date: this.getToday()
        }, { emitEvent: false });
        this.errormessage = '';
      } else {
        this.assessmentForm.patchValue({
          bdmname: null,
          date: null
        }, { emitEvent: false });
        if (value == false) {
          this.assessmentForm.get('declarationaccepted')?.markAllAsTouched();
        }
      }
    });
  }

  onDocumentFileChange(event: any, controlName: string, fileVar: string): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const control = this.assessmentForm.get(controlName);


    // ✅ Valid file → update form properly
    this.assessmentForm.patchValue({
      [fileVar]: file,
      [controlName]: file?.name
    });

    if (!control) return;

    // Reset first
    control.markAsTouched();
    control.setErrors(null);

    if (!file) {
      control.setValue(null);
      return;
    }

    const allowedTypes = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png'
    ]);

    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate type
    if (!allowedTypes.has(file.type)) {
      control.setErrors({ invalidType: true });
      return;
    }

    // Validate size
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      return;
    }

    control.updateValueAndValidity();
    this.uploaddocument(fileVar);
  }

  removeFile(controlName: string, fileVar: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.getBdmdocuments) {
          const match = this.findDocument(fileVar);

          const data = {
            onboardingId: this.viewId,
            docTypeId: match?.docTypeId,
            id: match?.id
          }
          const responseData = await this.documentUploadService
            .deleteonbordingdocument(data)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
        }
        this.assessmentForm.get(controlName)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.assessmentForm.get(fileVar)?.reset();
        this.assessmentForm.controls[controlName].markAsTouched();
        this.assessmentForm.controls[controlName].updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });
  }

  // ---------- Other Attachments ----------

  /**
   * Restores any previously uploaded "Other Attachments" from getBdmdocuments
   * and always keeps at least one empty row. Safe to call repeatedly (the
   * documents list is re-fetched after every upload) - restoreOtherAttachment()
   * only adds controls it hasn't seen.
   */
  private buildOtherAttachments(): void {
    this.getBdmdocuments?.forEach(item => {
      const index = this.otherAttachmentIndexOf(item);
      if (index !== null) {
        this.restoreOtherAttachment(`${this.otherAttachmentPrefix}${index}`, item.fileName);
      }
    });

    if (this.otherAttachmentKeys.length === 0) {
      this.addOtherAttachment();
    }

    // The API lists the documents in its own order, so the rows are put back in row
    // order here. Left unsorted the fields swap places on every fetch, and because
    // the template hangs the remove button off every row but the first and the add
    // button off the last, those buttons end up on whichever rows came back first.
    this.otherAttachmentKeys.sort((a, b) => this.otherAttachmentRow(a) - this.otherAttachmentRow(b));
  }

  /** True when the control key belongs to an "Other Attachments" row. */
  private isOtherAttachmentKey(key: string): boolean {
    return key.startsWith(this.otherAttachmentPrefix);
  }

  /** The row index sent as responseValue for an "Other Attachments" control key. */
  private otherAttachmentIndex(key: string): string {
    return key.slice(this.otherAttachmentPrefix.length);
  }

  /** Row index of a control key as a number, for matching and ordering. */
  private otherAttachmentRow(key: string): number {
    return Number(this.otherAttachmentIndex(key));
  }

  /**
   * Row index an uploaded document belongs to, or null when it isn't an "Other
   * Attachments" row. Uploads carry 'OtherAttachments' as the document type with
   * the index in responseValue; rows saved before that change kept the index in
   * the document type itself, so both shapes are recognised here. The index is
   * read as a number so a row is still matched when the API echoes it back in a
   * different form (' 2', 2) than the one that was sent.
   */
  private otherAttachmentIndexOf(item: OnboardingAssesment | undefined): number | null {
    const docType = item?.onboardingDocumentType ?? '';
    const raw = docType === this.otherAttachmentDescription
      ? String(item?.responseValue ?? '').trim()
      : docType.startsWith(this.otherAttachmentPrefix)
        ? docType.slice(this.otherAttachmentPrefix.length)
        : '';

    const row = Number(raw);
    return raw !== '' && Number.isFinite(row) ? row : null;
  }

  /**
   * Locates the uploaded document behind a control key - "Other Attachments"
   * rows are matched on their index, every other field on its document type.
   */
  private findDocument(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.isOtherAttachmentKey(fileVar)
      ? this.getBdmdocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
      : this.getBdmdocuments?.filter(item => item?.onboardingDocumentType === fileVar);

    return matches?.[matches.length - 1];
  }

  private restoreOtherAttachment(key: string, fileName: string): void {
    if (!this.otherAttachmentKeys.includes(key)) {
      this.assessmentForm.addControl(key, this.fb.control([null]));
      this.assessmentForm.addControl(`${key}fileName`, this.fb.control(''));
      this.otherAttachmentKeys.push(key);

      const seq = Number(key.slice(this.otherAttachmentPrefix.length));
      if (!Number.isNaN(seq) && seq > this.otherAttachmentSeq) {
        this.otherAttachmentSeq = seq;
      }
    }
    this.assessmentForm.get(`${key}fileName`)?.setValue(fileName);
  }

  /** Duplicates the "Other Attachments" field so another file can be attached. */
  addOtherAttachment(): void {
    const key = `${this.otherAttachmentPrefix}${++this.otherAttachmentSeq}`;
    this.assessmentForm.addControl(key, this.fb.control([null]));
    this.assessmentForm.addControl(`${key}fileName`, this.fb.control(''));
    this.otherAttachmentKeys.push(key);
  }

  /** Removes a duplicated "Other Attachments" row, deleting its uploaded file first when there is one. */
  removeOtherAttachment(key: string): void {
    if (!this.assessmentForm.get(`${key}fileName`)?.value) {
      this.dropOtherAttachment(key);
      return;
    }

    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        await this.deleteOtherAttachmentDocument(key);
        this.dropOtherAttachment(key);
      }
    });
  }

  private async deleteOtherAttachmentDocument(key: string): Promise<void> {
    const match = this.findDocument(key);
    if (!match?.id) {
      return;
    }

    const data = {
      onboardingId: this.viewId,
      docTypeId: match.docTypeId,
      id: match.id
    };

    await this.documentUploadService
      .deleteonbordingdocument(data)
      .then((response) => JSON.parse(response))
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.getBdmdocuments = this.getBdmdocuments.filter(item => item !== match);
  }

  private dropOtherAttachment(key: string): void {
    this.assessmentForm.removeControl(key);
    this.assessmentForm.removeControl(`${key}fileName`);
    this.otherAttachmentKeys = this.otherAttachmentKeys.filter(item => item !== key);
  }

  async viewdocuments() {
    this.setSprinner.set(true);
    const responseData = await this.bdmassessmentService
      .getBdmdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.getBdmdocuments = responseData.data.responsedata;

      this.getBdmdocuments.forEach(item => {
        if (item?.onboardingDocumentType === 'medisavePayableStatementbyCPFBoard') {
          this.assessmentForm.controls['medisavePayableStatementbyCPFBoardfileName']?.setValue(item?.fileName);
        } else if (item?.onboardingDocumentType === 'adviserAgreement') {
          this.assessmentForm.controls['adviserAgreementfileName']?.setValue(item?.fileName);
        } else if (item?.onboardingDocumentType === 'cdoApproval') {
          this.assessmentForm.controls['cdoApprovalfileName']?.setValue(item?.fileName);
        }
      })

      this.buildOtherAttachments();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }

  async getChecklistItems() {
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      this.getchecklistItems = this.getchecklistItems.filter(
        x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
      );
      const preferredOrder = [
        "minimumDocumentCheck_",
        "subsequentDocumentsCheck_",
      ];

      const getCategoryOrder = (categoryName = "") => {
        const index = preferredOrder.findIndex(prefix =>
          categoryName.startsWith(prefix)
        );
        return index === -1 ? preferredOrder.length : index;
      };

      const getSuffixNumber = (categoryName = "") => {
        const match = categoryName.match(/_(\d+)$/);
        return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
      };

      this.getchecklistItems.sort((a, b) => {
        const orderA = getCategoryOrder(a.categoryName);
        const orderB = getCategoryOrder(b.categoryName);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
      });

      this.checklistinvalidflag.set(
        this.getchecklistItems.filter(
          x => x.categoryName?.startsWith('minimumDocumentCheck_')
        ).length === 0 ||
        this.getchecklistItems
          .filter(x => x.categoryName?.startsWith('minimumDocumentCheck_'))
          .some(x => x.isCompleted == null || x.isCompleted == false)
      );

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async uploaddocument(fileVar: string) {
    this.setSprinner.set(true);
    const isOtherAttachment = this.isOtherAttachmentKey(fileVar);
    let uploadbdmdocuments = new OnboardingAssesmentModel();
    uploadbdmdocuments.setOnboardingid(this.viewId);
    uploadbdmdocuments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadbdmdocuments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: isOtherAttachment ? this.otherAttachmentDescription : fileVar,
      fileName: this.assessmentForm.get(fileVar)?.value?.name,
      data: this.assessmentForm.get(fileVar)?.value instanceof Blob ? await this.convertToBase64(this.assessmentForm.get(fileVar)?.value) : '',
      contentType: this.assessmentForm.get(fileVar)?.value?.type,
      responseValue: isOtherAttachment ? this.otherAttachmentIndex(fileVar) : ''
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadbdmdocuments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      this.viewdocuments();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }
  }

  showPreview = false;

  async previewAttachment(controlName: string, filename: string) {
    this.selectedItemFile = controlName;
    await this.loadOtherFile(controlName, filename);
    this.showPreview = true;

  }

  private findAttachment(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.getBdmdocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
    return matches?.[matches.length - 1];
  }

  async loadOtherFile(category: string, filename: string) {

    const documentId = this.findAttachment(category)?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.assessmentForm.get(filename)?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.assessmentForm.get(filename)?.value;
      this.resetZoom();
    }
  }

  async previewDoc(category: string) {
    this.selectedItemFile = category;
    await this.loadFile(category);
    this.showPreview = true;

  }

  async loadFile(category: string) {

    const documentId = this.findDocument(category)?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.assessmentForm.get(category + 'fileName')?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.assessmentForm.get(category + 'fileName')?.value;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }

  async viewBdmAssessment() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.bdmassessmentService
      .viewBdmAssessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    const responseData1 = await this.bdmassessmentService
      .getBdmdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewbdmAssessment = responseData.data.responsedata;
      this.getBdmdocuments = responseData1.data.responsedata;

      this.viewbdmAssessment.Checklist = this.viewbdmAssessment.Checklist.filter(
        x => x.categoryName.startsWith('recruitmentQuestionnaires_') || x.categoryName.startsWith('bdmAssessmentChecklist_')
      );
      const preferredOrder = [
        "recruitmentQuestionnaires_",
        "bdmAssessmentChecklist_"
      ];

      const getCategoryOrder = (categoryName = "") => {
        const index = preferredOrder.findIndex(prefix =>
          categoryName.startsWith(prefix)
        );
        return index === -1 ? preferredOrder.length : index;
      };

      const getSuffixNumber = (categoryName = "") => {
        const match = categoryName.match(/_(\d+)$/);
        return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
      };

      this.viewbdmAssessment.Checklist.sort((a, b) => {
        const orderA = getCategoryOrder(a.categoryName);
        const orderB = getCategoryOrder(b.categoryName);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
      });


      this.assessmentForm.controls['name'].setValue(this.viewbdmAssessment.declaration.fullname);
      this.assessmentForm.controls['manager'].setValue(this.viewbdmAssessment.declaration.managerName);
      this.assessmentForm.controls['recruitmentQuestionnaires_1'].setValue(this.viewbdmAssessment.Checklist[0]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_2'].setValue(this.viewbdmAssessment.Checklist[1]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_3'].setValue(this.viewbdmAssessment.Checklist[2]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_4'].setValue(this.viewbdmAssessment.Checklist[3]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_5'].setValue(this.viewbdmAssessment.Checklist[4]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_6'].setValue(this.viewbdmAssessment.Checklist[5]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_7'].setValue(this.viewbdmAssessment.Checklist[6]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_8'].setValue(this.viewbdmAssessment.Checklist[7]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_9'].setValue(this.viewbdmAssessment.Checklist[8]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_10'].setValue(this.viewbdmAssessment.Checklist[9]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_11'].setValue(this.viewbdmAssessment.Checklist[10]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_12'].setValue(this.viewbdmAssessment.Checklist[11]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_13'].setValue(this.viewbdmAssessment.Checklist[12]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_14'].setValue(this.viewbdmAssessment.Checklist[13]?.isCompleted);
      this.assessmentForm.controls['recruitmentQuestionnaires_15'].setValue(this.viewbdmAssessment.Checklist[14]?.isCompleted);

      this.assessmentForm.controls['remarks'].setValue(this.viewbdmAssessment?.remark?.remarkContent);

      if (this.viewbdmAssessment.Checklist[0]?.isCompleted == true) {
        let value = this.viewbdmAssessment.Checklist[0]?.responseValue.split(',');
        this.assessmentForm.controls['recruitmentQuestionnairesyes_1_1']?.setValue(value[0]);
        this.assessmentForm.controls['recruitmentQuestionnairesyes_1_2']?.setValue(value[1]);
      }

      if (this.viewbdmAssessment.Checklist[1]?.isCompleted == true) {
        let value = this.viewbdmAssessment.Checklist[1]?.responseValue;
        this.assessmentForm.controls['recruitmentQuestionnairesyes_2']?.setValue(value);
      }

      if (this.viewbdmAssessment.Checklist[4]?.isCompleted == false) {
        let value = this.viewbdmAssessment.Checklist[4]?.responseValue;
        this.assessmentForm.controls['recruitmentQuestionnairesno_5']?.setValue(value);
      }

      if (this.viewbdmAssessment.Checklist[5]?.isCompleted == true) {
        let value = this.viewbdmAssessment.Checklist[5]?.responseValue;
        this.assessmentForm.controls['recruitmentQuestionnairesyes_6']?.setValue(value);
      }

      if (this.viewbdmAssessment.Checklist[8]?.isCompleted == true) {
        let value = this.viewbdmAssessment.Checklist[8]?.responseValue.split(',');
        this.assessmentForm.controls['recruitmentQuestionnairesyes_9_1']
          ?.setValue(value[0] ? new Date(value[0]) : null);
        this.assessmentForm.controls['recruitmentQuestionnairesyes_9_2']?.setValue(value[1]);
      } else {
        let value = this.viewbdmAssessment.Checklist[8]?.responseValue;
        this.assessmentForm.controls['recruitmentQuestionnairesno_9']?.setValue(value);
      }

      if (this.viewbdmAssessment.Checklist[14]?.isCompleted == true) {
        let value = this.viewbdmAssessment.Checklist[14]?.responseValue;
        this.assessmentForm.controls['recruitmentQuestionnairesyes_15']?.setValue(value);
      }

      this.getBdmdocuments.forEach(item => {
        if (item?.onboardingDocumentType === 'medisavePayableStatementbyCPFBoard') {
          this.assessmentForm.controls['medisavePayableStatementbyCPFBoardfileName']?.setValue(item?.fileName);
        } else if (item?.onboardingDocumentType === 'adviserAgreement') {
          this.assessmentForm.controls['adviserAgreementfileName']?.setValue(item?.fileName);
        } else if (item?.onboardingDocumentType === 'cdoApproval') {
          this.assessmentForm.controls['cdoApprovalfileName']?.setValue(item?.fileName);
        }
      })

      this.buildOtherAttachments();

      this.assessmentForm.controls['declarationaccepted'].setValue(this.viewbdmAssessment.declaration.bdmIsAgree);
      if (this.assessmentForm.get('declarationaccepted')?.value == true) {
        this.assessmentForm.controls['bdmname'].setValue(this.viewbdmAssessment.declaration.bdmname);
        this.assessmentForm.controls['date'].setValue(this.viewbdmAssessment.declaration.bdmDeclarationDate?.split('T')[0]);
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }


  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: ' Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });
    this.getChecklistItems();
    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.assessmentForm.get('declarationaccepted')?.value == true) {
          if (this.checklistinvalidflag() === true) {
            this.errormessage = 'Please complete the checklist';
            this.submitted.set(false);
          } else {
            this.submitted.set(true);
            this.saveAndContinue();
          }
        } else {
          this.errormessage = 'Please check the decleartion';
          this.submitted.set(false);
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveBdmassessment = new Bdmassessmentmodels();
    saveBdmassessment.setOnboardingid(this.viewId);
    saveBdmassessment.setChecklists([
      {
        id: this.viewbdmAssessment.Checklist[0]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[0]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_1',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_1')?.value,
        response_value: [this.assessmentForm.get('recruitmentQuestionnairesyes_1_1')?.value?.trim(), this.assessmentForm.get('recruitmentQuestionnairesyes_1_2')?.value?.trim()].toString(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[1]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[1]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_2',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_2')?.value,
        response_value: this.assessmentForm.get('recruitmentQuestionnairesyes_2')?.value?.trim(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[2]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[2]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_3',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_3')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[3]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[3]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_4',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_4')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[4]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[4]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_5',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_5')?.value,
        response_value: this.assessmentForm.get('recruitmentQuestionnairesno_5')?.value?.trim(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[5]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[5]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_6',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_6')?.value,
        response_value: this.assessmentForm.get('recruitmentQuestionnairesyes_6')?.value?.trim(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[6]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[6]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_7',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_7')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[7]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[7]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_8',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_8')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[8]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[8]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_9',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_9')?.value,
        response_value: this.assessmentForm.get('recruitmentQuestionnaires_9')?.value == true ? [this.assessmentForm.get('recruitmentQuestionnairesyes_9_1')?.value, this.assessmentForm.get('recruitmentQuestionnairesyes_9_2')?.value].toString() : this.assessmentForm.get('recruitmentQuestionnairesno_9')?.value?.trim(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[9]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[9]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_10',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_10')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[10]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[10]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_11',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_11')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[11]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[11]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_12',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_12')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[12]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[12]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_13',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_13')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[13]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[13]?.id,
        question_id: 0,
        category_name: 'recruitmentQuestionnaires_14',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_14')?.value,
        response_value: '',
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
      {
        id: this.viewbdmAssessment.Checklist[14]?.id == 0 ? 0 : this.viewbdmAssessment.Checklist[14]?.id,
        question_id: 0,
        category_name: 'bdmAssessmentChecklist_1',
        is_completed: this.assessmentForm.get('recruitmentQuestionnaires_15')?.value,
        response_value: this.assessmentForm.get('recruitmentQuestionnairesyes_15')?.value?.trim(),
        updated_by_role: this.sessionStorageService.getCurrentUserRole()
      },
    ]);
    saveBdmassessment.setRemarkId(this.viewbdmAssessment?.remark?.id);
    saveBdmassessment.setRemarkContent(this.assessmentForm.get('remarks')?.value?.trim());
    saveBdmassessment.setupdatedbyroleRemark(this.sessionStorageService.getCurrentUserRole());
    if (this.submitted() == true) {
      saveBdmassessment.setbdmName(this.assessmentForm.get('bdmname')?.value);
      saveBdmassessment.setIs_completed(this.assessmentForm.get('declarationaccepted')?.value);
      saveBdmassessment.setDeclaration_date(this.assessmentForm.get('date')?.value + 'T00:00:00Z');
    } else {
      saveBdmassessment.setIs_completed(false);
    }


    const responseData = await this.bdmassessmentService
      .saveBdmAssessment(saveBdmassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewBdmAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }

}
